<script>
export default {
    name: "BtnRelated"
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="29.41" height="29.41" viewBox="0 0 29.41 29.41">
        <g id="Group_1321" data-name="Group 1321" transform="translate(-15.525 -17.202)">
            <g id="Group_914" data-name="Group 914" transform="translate(15.525 17.202)">
                <path id="Path_1070" data-name="Path 1070" d="M24.088,12.574,12.221.707.354,12.574l-.707-.707L12.221-.707,24.795,11.867Z" transform="translate(18.784 2.571) rotate(90)" fill="#fff"/>
                <path id="Ellipse_48" data-name="Ellipse 48" d="M14.7,1A13.7,13.7,0,0,0,5.014,24.4,13.7,13.7,0,1,0,24.4,5.014,13.615,13.615,0,0,0,14.7,1m0-1A14.7,14.7,0,1,1,0,14.7,14.7,14.7,0,0,1,14.7,0Z" fill="#fff"/>
            </g>
        </g>
    </svg>
</template>